// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__y4Czz"};